// extracted by mini-css-extract-plugin
export default {"recentlyViewed":"_bbb2c523"};